var _rect, _rect2, _rect3, _rect4, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForms1C12E(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 48,
    viewBox: "0 0 168 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 48,
    rx: 5.17736,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.47156,
    y: 3,
    width: 42.7132,
    height: 42.7132,
    rx: 21.3566,
    fill: "#5568FE",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3606,
    y: 12.8893,
    width: 22.6529,
    height: 22.6529,
    rx: 11.3264,
    stroke: "#5568FE",
    strokeWidth: 1.65753
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9519,
    y: 16.48,
    width: 15.4703,
    height: 15.4703,
    rx: 7.73513,
    fill: "#5568FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.3118 29.6489V28.0223H53.3889V17.1136H51.6562V29.6489H59.3118ZM60.4234 27.3682C60.4234 28.7119 61.5373 29.9141 63.2699 29.9141C64.7904 29.9141 65.6391 29.1008 66.0104 28.4997C66.0104 29.1185 66.0634 29.4368 66.0988 29.6489H67.7254C67.69 29.4368 67.6193 28.9948 67.6193 28.2522V23.9912C67.6193 22.3293 66.6292 20.8795 64.0832 20.8795C62.2445 20.8795 60.777 22.011 60.6002 23.6376L62.1914 24.0089C62.2975 23.0188 62.9517 22.2939 64.1186 22.2939C65.4092 22.2939 65.9573 22.9835 65.9573 23.8144C65.9573 24.115 65.8159 24.3802 65.3032 24.4509L63.0047 24.7868C61.5373 24.999 60.4234 25.8477 60.4234 27.3682ZM63.4998 28.5174C62.6511 28.5174 62.1207 27.9163 62.1207 27.2798C62.1207 26.5195 62.6511 26.1129 63.3583 26.0068L65.9573 25.6178V26.0068C65.9573 27.8632 64.8612 28.5174 63.4998 28.5174ZM71.888 29.6489V28.4113C72.4184 29.3307 73.3908 29.8788 74.6461 29.8788C77.1744 29.8788 78.6065 27.8809 78.6065 25.3526C78.6065 22.8774 77.2805 20.8972 74.6991 20.8972C73.2847 20.8972 72.2946 21.5867 71.888 22.347V16.8484H70.2437V29.6489H71.888ZM76.9092 25.3526C76.9092 27.1914 75.9191 28.3936 74.3986 28.3936C72.9311 28.3936 71.8703 27.1914 71.8703 25.3526C71.8703 23.5139 72.9311 22.3646 74.3986 22.3646C75.9368 22.3646 76.9092 23.5139 76.9092 25.3526ZM81.9436 24.5216C82.0144 23.4255 82.863 22.347 84.2598 22.347C85.7626 22.347 86.5582 23.3017 86.5936 24.5216H81.9436ZM86.8411 26.7317C86.5228 27.6864 85.8333 28.4467 84.4542 28.4467C83.0221 28.4467 81.926 27.3858 81.8906 25.8653H88.2909C88.3085 25.7593 88.3262 25.5471 88.3262 25.3349C88.3262 22.6829 86.8588 20.8795 84.2421 20.8795C82.1028 20.8795 80.1756 22.7006 80.1756 25.3703C80.1756 28.2522 82.1735 29.9141 84.4542 29.9141C86.4344 29.9141 87.7958 28.7296 88.2732 27.2267L86.8411 26.7317ZM92.0722 29.6489V16.8484H90.4103V29.6489H92.0722Z",
    fill: "#14121D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms1C12E);
export default __webpack_public_path__ + "static/media/forms1c12e.ed66d393d4fc94c7a72ba3f77169f0e9.svg";
export { ForwardRef as ReactComponent };